export default __webpack_public_path__ + "static/media/cmd.aa844655.jpg";